// extracted by mini-css-extract-plugin
export var chip = "_59-0";
export var filterDropdown = "_59-5";
export var filterItem = "_59-6";
export var icon = "_59-1";
export var removeButton = "_59-3";
export var removeIcon = "_59-4";
export var separator = "_59-2";